import React from "react";
import { useTranslation } from "react-i18next";
import { Assignees } from "../types";
import { APPROVAL_ROLES, DirectoryUser } from "./useDirectory";
import { UserGroup } from "../types";

interface Props {
    id: string;
    value: Assignees;
    onChange: (value: Assignees) => void;
    users: DirectoryUser[];
    groups: UserGroup[];
    disabled?: boolean;
}

/** Users, groups and roles, as three compact checkbox lists. */
const AssigneePicker = ({ id, value, onChange, users, groups, disabled }: Props) => {
    const { t } = useTranslation(['workflow', 'role']);

    const toggle = (key: keyof Assignees, item: string) => {
        const list = value[key] || [];
        onChange({ ...value, [key]: list.includes(item) ? list.filter((v) => v !== item) : [...list, item] });
    };

    const column = (key: keyof Assignees, title: string, items: { value: string; label: string }[]) => (
        <div className="col-md-4 mb-2">
            <div className="small fw-semibold mb-1">{title}</div>
            <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                {items.length === 0 && <div className="text-muted small">—</div>}
                {items.map((item) => (
                    <div key={item.value} className="form-check">
                        <input id={id + key + item.value} className="form-check-input" type="checkbox" disabled={disabled}
                            checked={(value[key] || []).includes(item.value)} onChange={() => toggle(key, item.value)} />
                        <label className="form-check-label small" htmlFor={id + key + item.value}>{item.label}</label>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="row">
            {column('users', t('workflow:users'), users.map((u) => ({ value: u.uuid, label: u.name || u.email || u.uuid })))}
            {column('groups', t('workflow:groups'), groups.map((g) => ({ value: g.uuid, label: g.name })))}
            {column('roles', t('workflow:roles'), APPROVAL_ROLES.map((r) => ({ value: r, label: t('role:' + r, { defaultValue: r }) })))}
        </div>
    );
};

export default AssigneePicker;
